import styled from 'styled-components';

export default styled.div`
  padding: 30px 0;
  &.empty {
    padding: 15px 0 15px 0;
  }
`;
